import React from 'react';
import { Plus } from 'lucide-react';

interface CanvasEmptyStateProps {
  className?: string;
}

export function CanvasEmptyState({ className = '' }: CanvasEmptyStateProps) {
  return (
    <div className={`absolute inset-0 flex items-center justify-center pointer-events-none ${className}`}>
      <div className="text-center space-y-3">
        <div className="w-12 h-12 bg-gray-800/80 rounded-full flex items-center justify-center mx-auto">
          <Plus className="w-6 h-6 text-gray-400" />
        </div>
        <div>
          <h3 className="text-base font-medium text-gray-300">Start Building Your Workflow</h3>
          <p className="text-sm text-gray-400 mt-1 max-w-md">
            Drag components from the sidebar or click the + button to add nodes
          </p>
        </div>
      </div>
    </div>
  );
}
